
export function Faq() {
  return (
    <div>
      <br />
      <h2 className="bold text-center">
        <p>Frequently Asked Questions</p>
      </h2>      
      <h4 className="bold">Is my donation tax deductible?</h4>
      <p>BLM encourages donors to consult their tax professionals regarding their donations.</p>

      <h4 className="bold">Will I get a receipt for my donation?</h4>
      <p>Donors will receive a payment confirmation from Pay.gov and a certificate with the date and amount of their donation.</p>

      <h4 className="bold">How do I include a donation to the WHB Program in my will?</h4>
      <p>BLM encourages donors to consult with their estate planners regarding any bequests to the Wild Horse and Burro Program.</p>

      <h4 className="bold">Can I donate more than $249?</h4>
      <p>
        Yes, you can! Please contact the Wild Horse and Burro National Information Center
        at <a href={`mailto:${window.config.SiteContactEmail}`}>{window.config.SiteContactEmail}</a> or {window.config.SiteContactPhone} to
        make a donation larger than $249.
      </p>

      <h4 className="bold">Can I make recurring donations through the online portal?</h4>
      <p>The online portal is not currently set up to allow recurring automatic donations. However, donors may return to the online portal as
        often as they wish to make donations not exceeding $249 total in one year.
      </p>

      <h4 className="bold">Can I donate in someone's honor or in memory of a loved one?</h4>
      <p>Yes. Donors may choose to donate on behalf of someone else.</p>

      <h4 className="bold">Can I donate anonymously?</h4>
      <p>No. Donors' names are required to process their donations.</p>

      <h4 className="bold">Will my donation automatically add me to an email or mailing list? (How do I opt out?)</h4>
      <p>
        Yes. BLM may engage donors to provide updates and information about a variety of Wild Horse and Burro activities and initiatives.
        To opt out of this outreach component, contact the WHB National Information Center
        at <a href={`mailto:${window.config.SiteContactEmail}`}>{window.config.SiteContactEmail}</a> or {window.config.SiteContactPhone}.
      </p>

      <h4 className="bold">Can I donate by phone or by mail?</h4>
      <p>
        Yes. To donate by phone or by mail contact the Wild Horse and Burro National Information Center
        at <a href={`mailto:${window.config.SiteContactEmail}`}>{window.config.SiteContactEmail}</a> or {window.config.SiteContactPhone}.
      </p>

      <h4 className="bold">Can I restrict the activities for which my donation is used?</h4>
      <p>
        No. Donations will be made without condition and used to support Wild Horse and Burro management on and off the range. 
      </p>

      <h4 className="bold">Is my donation secure?</h4>
      <p>Yes. Donations through this website are secured through Pay.gov.</p>

      <h4 className="bold">Can I donate if I live outside of the United States?</h4>
      <p>
        Yes. Individuals residing outside the United States may donate to the Wild Horse and Burro Program, but remittances can only be
        accepted in U.S. currency.
      </p>

      <h4 className="bold">How can I volunteer to care for the animals?</h4>
      <p>
        Volunteers help the Wild Horse and Burro Program in many ways, including promoting adoptions and educating the public about these amazing
        animals. Volunteers also help with conducting compliance checks to make sure newly adopted animals are in good care. They may also help
        with range improvements and other on-range management activities. To find volunteer opportunities in the Wild Horse and Burro
        Program, <a href="https://www.blm.gov/programs/wild-horse-and-burro/contacts" target="_blank" rel="noreferrer">contact a BLM Office near you</a>.
      </p>

      <h4 className="bold">Will my donation be used for animal gathers?</h4>
      <p>
        Potentially. Donations will be used to support a wide array of Wild Horse and Burro management activities. This may include gathers and
        removals to ensure healthy herds on healthy rangelands.
      </p>
    </div>
  );
}